import React, { useEffect, useState } from "react";
import QuickSightDashboard from "./QuickSightDashboard";
import { config } from "../../../config/awsExports";
import { useProject } from "../../../config/ProjectContext";

const MQTTUserAnalyticsDashboard: React.FC = () => {
  const { env } = config;
  const dashboardId = env.quickSightDashboardIds.MQTTUserAnalyticsDashboard;
  const { project, selectedProjects } = useProject();

  // Calcula la key y el projectId a partir del contexto
  const getKey = (projs: any[], proj: any) => {
    if (projs && projs.length > 0) {
      return projs.map((p) => p.code).join(",");
    }
    return proj?.code || "";
  };

  const getProjectId = (projs: any[], proj: any): string | string[] => {
    if (projs && projs.length > 1) {
      return projs.map((p) => p.code);
    }
    if (projs && projs.length === 1) {
      return projs[0].code;
    }
    return proj?.code || "";
  };

  const [dashboardKey, setDashboardKey] = useState(() => getKey(selectedProjects, project));
  const [projectId, setProjectId] = useState<string | string[]>(() => getProjectId(selectedProjects, project));

  // Refresca el dashboard automáticamente cuando cambia la selección
  useEffect(() => {
    console.log("Dashboard key or project ID changed");
    setDashboardKey(getKey(selectedProjects, project));
    setProjectId(getProjectId(selectedProjects, project));
  }, [selectedProjects, project]);

  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      {/* Page Banner Replacement */}
      <header className="bg-white shadow">
        <div className="bg-[#F5936B] px-4 py-3">
          <h1 className="text-xl text-white ">MQTT Analytics Dashboard</h1>
        </div>
      </header>

      {/* Main content area */}
      <main className="flex-grow p-4">
        <QuickSightDashboard id={dashboardId} projectId={projectId} key={dashboardKey} />
      </main>
    </div>
  );
};

export default MQTTUserAnalyticsDashboard;
